import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { Checkbox } from 'semantic-ui-react'
import classnames from 'classnames/bind'
import commonPropTypes from '../../../constants/commonPropTypes'
import { formFieldWrapper } from '../formFieldWrapper'
import StandardFieldLabel from '../formFieldWrapper/standardFieldLabel'
import PendingTooltip from '../formFieldWrapper/pendingTooltip'
import { getThemedCompact } from '../util'
import { withApplicationTheme } from '../../applicationTheme'
import styles from './styles.scss'
const cx = classnames.bind(styles)

export const roles = ['action', 'info', 'success', 'caution', 'error']

const BaseCheckboxField = ({
  checkboxLabel, // custom label - for backward compatibility
  className = '',
  elmId = 'base_checkbox_field',
  onChange,
  role = roles[0],
  onBlur,
  showError, // eslint-disable-line
  compact = undefined, // eslint-disable-line
  viewMode, // eslint-disable-line
  size, // deprecated but here for backward compatibility
  value,
  toggle,
  label,
  valueAsArray = false, // if true, value will be converted from array to string (and vice versa onChange)
  showAnchor,
  helpContent,
  pendingApproval,
  theme,
  ...rest
}) => {
  let newCompact = getThemedCompact(theme, compact)

  if (typeof size !== 'undefined') {
    newCompact = size === 'small'
  }

  const labelProps = {
    checkboxType: 'checkbox',
    compact: newCompact,
    className,
    elmId,
    showAnchor,
    helpContent,
  }

  const newLabel =
    checkboxLabel || StandardFieldLabel.createFromLabel(label, labelProps)

  const defaultCheckboxClassNames = [
    'rtc-checkbox',
    !newCompact ? 'ch-md' : '',
    !(label || checkboxLabel) ? 'no-label' : '',
    className,
    _.kebabCase(role),
  ]

  const classNames = toggle ? [className] : defaultCheckboxClassNames

  const newOnChange = (e, data) => {
    if (valueAsArray && typeof data.value === 'string') {
      data.value = data.value.split(',')
    }
    onChange(e, data)
  }

  const newValue = valueAsArray
    ? Array.isArray(value) && value.join(',')
    : value

  return (
    <div className={cx('wrapper')}>
      {pendingApproval && <PendingTooltip style={{ padding: '3px 0' }} />}
      <Checkbox
        data-elm-id={`${elmId}_checkbox`}
        aria-label={`${elmId}_checkbox`}
        className={cx(...classNames)}
        toggle={toggle}
        label={newLabel}
        onBlur={onBlur}
        onChange={newOnChange}
        value={newValue}
        {...rest}
      />
    </div>
  )
}

BaseCheckboxField.propTypes = {
  ...commonPropTypes,
  toggle: PropTypes.bool,
  checkboxLabel: PropTypes.node,
  role: PropTypes.oneOf(roles),
  size: PropTypes.string, // no size indicates the standard small size, like react-toolkit-adc only supports small & medium (25x25)
  valueAsArray: PropTypes.bool,
  showAnchor: PropTypes.bool,
  helpContent: PropTypes.node,
}

export default withApplicationTheme(
  formFieldWrapper((fieldProps, showError) => (
    <BaseCheckboxField {...fieldProps} showError={showError} />
  ))
)
